import { reminderPermission } from './reminders';

// What the app can say about the device it runs on, for feedback messages and the admin user page. Nothing personal.

// "iPhone · iOS 18.1", "Android 15", "Mac", "Windows": enough to reproduce, nothing personal.
export function deviceInfo() {
  const ua = navigator.userAgent;
  const ios = ua.match(/(iPhone|iPad|iPod).*? OS (\d+[_\d]*)/);
  if (ios) return { device: ios[1], os: `iOS ${ios[2].replace(/_/g, '.')}` };
  const android = ua.match(/Android (\d+[.\d]*)/);
  if (android) return { device: (ua.match(/Android [^;]+; ([^;)]+)/)?.[1] || 'Android').trim(), os: `Android ${android[1]}` };
  if (/Macintosh/.test(ua)) return { device: navigator.maxTouchPoints > 1 ? 'iPad' : 'Mac', os: 'macOS' };
  if (/Windows/.test(ua)) return { device: 'PC', os: 'Windows' };
  return { device: 'Khác', os: navigator.platform || 'Khác' };
}

export async function appVersion(native) {
  if (!native) return 'web';
  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    return `${info.version} (${info.build})`;
  } catch {
    return 'app';
  }
}

// Whether the app may show notifications: the phone's own setting in the app, the browser's on the web.
async function notificationPermission(native) {
  try {
    if (native) return await reminderPermission();
    return typeof Notification === 'undefined' ? 'unsupported' : Notification.permission;
  } catch {
    return 'unknown';
  }
}

// Sent with each app open (UserEvent "app_open"): version, system, device, notifications, language, time zone.
export async function deviceContext(native) {
  let timeZone = '';
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    // An old browser without Intl time zones: left out.
  }
  return {
    app_version: await appVersion(native), ...deviceInfo(), notifications: await notificationPermission(native),
    language: navigator.language || '', time_zone: timeZone,
  };
}
